module.exports = __webpack_public_path__ + "img/mealreminder-text-small.e41d8fca.png";